// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../../../stores/mobx-compat";

import Card from '../../../ui/Card';
import Pill from '../../../ui/Pill';
import { CheckCircleIcon, PinIcon } from '../../../ui/icons';

class CapturePlans extends Component {
  formatMoney = (num) => {
    if (!num) return '';
    const numText = String(num);
    if (numText.length === 1) return 'Free';
    return `$${numText.slice(0, -2)}.${numText.slice(-2)} / month`;
  }

  badge = (id) => {
    const { selectedPlan } = this.props.store.payments;
    const { planObj = {} } = this.props.store.accountStatus;
    if (id === planObj.id) {
      return <Pill tone="gray" dot>Current</Pill>;
    }
    if (id === selectedPlan[0]) {
      return <Pill tone="green" dot>Selected</Pill>;
    }
    return null;
  }

  card = (plan) => {
    const { nickname, amount, metadata, id } = plan;
    const { limit, domains, email, description, hide } = metadata;
    if (hide) return null;
    const { selectedPlan } = this.props.store.payments;
    const { planObj = {} } = this.props.store.accountStatus;
    const isCurrent = id === planObj.id;
    const isSelected = id === selectedPlan[0];

    return (
      <Card
        key={id}
        padded
        interactive
        className="cursor-pointer flex flex-col"
        onClick={() => this.props.store.payments.planSelector(id)}
        style={{
          borderColor: isSelected ? 'var(--mov-accent)' : isCurrent ? 'var(--mov-ink-mute)' : 'var(--mov-line)',
          boxShadow: isSelected ? '0 0 0 3px var(--mov-accent-soft)' : undefined,
        }}
      >
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="m-0 text-[16px] font-semibold">{nickname}</h3>
          {this.badge(id)}
        </div>
        <p className="m-0 text-[12.5px] text-mov-ink-soft" style={{ minHeight: 38 }}>{description}</p>
        <div className="mov-display mt-3" style={{ fontSize: 28, lineHeight: 1 }}>
          {this.formatMoney(amount)}
        </div>
        <ul className="m-0 mt-3 p-0 list-none flex flex-col gap-2 text-[12.5px]">
          <li className="flex items-start gap-2">
            <CheckCircleIcon size={13} className="text-mov-accent-ink shrink-0 mt-0.5" />
            {email === 'true' ? 'Email remarketing unlocked' : 'No remarketing'}
          </li>
          <li className="flex items-start gap-2">
            <CheckCircleIcon size={13} className="text-mov-accent-ink shrink-0 mt-0.5" />
            Form tracking on {domains === '1' ? '1 domain' : `${domains} domains`}
          </li>
          <li className="flex items-start gap-2">
            <CheckCircleIcon size={13} className="text-mov-accent-ink shrink-0 mt-0.5" />
            Up to {limit} captures
          </li>
        </ul>
      </Card>
    );
  }

  render() {
    const plans = this.props.store.payments.availablePlans
      .slice()
      .sort((a, b) => a.metadata.order - b.metadata.order);
    return (
      <div
        className="grid gap-4"
        style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
      >
        {plans.map((p) => this.card(p))}
        <Card padded className="flex flex-col" style={{ borderStyle: 'dashed' }}>
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="m-0 text-[16px] font-semibold">Enterprise Plus</h3>
            <PinIcon size={14} className="text-mov-ink-mute" />
          </div>
          <p className="m-0 text-[12.5px] text-mov-ink-soft">
            Expecting high volume? Contact sales for a custom quote.
          </p>
          <a
            href="mailto:sales@automatedremarketing.com"
            className="mov-mono mt-3 text-[12.5px] text-mov-accent-ink underline"
          >
            sales@automatedremarketing.com
          </a>
        </Card>
      </div>
    );
  }
}

export default inject('store')(observer(CapturePlans));
